import { Response } from '../hooks/Request'
import request from './request'

export type QueryParams = {
  body?: Record<string, string | undefined>
  page?: string | number
  page_size?: string | number
  orderBy?: { sortField: string; sortOrder: string }[]
  ignoreError?: boolean
  headers?: Record<string, string>
  path?: string
  method?: string
}

export async function query(params: QueryParams, ignoreError?: boolean) {
  return request<Response<{ body: string; total: number }>>(params.path, {
    method: params.method,
    data: params.body,
    headers: params.headers,
    params: ignoreError ? { ignoreError } : undefined,
  })
}
